var DB_Modal = {
    init:function(){   
        document.querySelectorAll(".DB-modal--source .DB-modal--item").forEach(function(item){
            item.addEventListener("click", function(e){
                DB_Modal.move_btn_close(e);
                DB_Modal.open_modal(item);        
            })
        })

        document.querySelector(".DB-modal__shadow").addEventListener("click", function(){
            DB_Modal.close_modal();
        })
        document.querySelector(".DB-modal__shadow").addEventListener("mousemove", function(e){
            DB_Modal.move_btn_close(e);
        });
        document.querySelector(".DB-modal__container .DB-modal__btn-close").addEventListener("click", function(){
            DB_Modal.close_modal();
        })
    },
    open_modal:function(item){
        var _title = item.querySelector(".DB-modal-title").innerHTML;
        var _text = item.querySelector(".DB-modal-text").innerHTML;
        document.querySelector(".DB-modal .DB-modal__title").innerHTML = _title;
        document.querySelector(".DB-modal .DB-modal__text").innerHTML = _text;
        document.querySelector(".DB-modal").classList.add("open");
        document.querySelector("body").classList.add("no-scroll");
    },
    close_modal:function(){
        document.querySelector(".DB-modal").classList.remove("open");
        document.querySelector("body").classList.remove("no-scroll");
    },
    move_btn_close:function(e){
        document.querySelector(".DB-modal__shadow .DB-modal__btn-close").style.left = e.clientX + "px";
        document.querySelector(".DB-modal__shadow .DB-modal__btn-close").style.top = e.clientY + "px";
    }
}

window.addEventListener("load", function(){
    if(document.querySelectorAll(".DB-modal--source").length > 0){
        DB_Modal.init();
    }
})

